import type { CalendarEvent } from '@/api/client';
import { cn } from '@/lib/utils';

/**
 * O evento é da agenda de um colega: um processo de que o usuário cuida no escritório
 * (docs/PLANO_COMPARTILHAMENTO_ESCRITORIO.md, Bloco 5). Lido do registro do dono, sem
 * cópia — editar muda o evento na agenda dele. Nada no evento do próprio usuário.
 */
export function DaAgendaDe({ evento, className }: { evento: CalendarEvent; className?: string }) {
  if (!evento.dono) return null;
  return (
    <span className={cn('break-words text-muted-foreground', className)}>
      da agenda de {evento.dono.nome || 'um colega'}
    </span>
  );
}
